class ParticipantsPictures extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init() {
    const el = this.querySelector('.participants-pictures-swiper')
    const nextBtn = this.querySelector('.swiper-button-next')
    const prevBtn = this.querySelector('.swiper-button-prev')
    new Swiper(el, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      breakpoints: {
        750: {
          slidesPerView: 3.5
        },
        1024: {
          slidesPerView: 5.5
        },
        1400: {
          slidesPerView: 7.5
        }
      },
      freeMode: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }
}

window.customElements.define('participants-pictures', ParticipantsPictures);